<template>
  <div class="pay">
    <!-- <van-nav-bar title="填写订单"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" /> -->
    <div class="pay-cont">
      <van-cell-group>
        <!-- 联系人卡片 -->
        <van-contact-card :type="cardType"
                          :name="currentContact.name"
                          :tel="currentContact.tel"
                          :address="currentContact.address"
                          @click="showList = true" />
        <van-cell>
          <div class='bill clearfix'>
            <span>发票</span>
            <span></span>
            <span>电子(个人)</span>
          </div>
          <div class='bill clearfix'>
            <span>订单备注</span>
            <span></span>
            <span style='float:left;margin-left:0.2rem'>选填 请先和商家协商一致</span>
          </div>
          <div class='goodMsg clearfix'>
            <span>商品信息</span>
          </div>
        </van-cell>
        <!-- 联系人列表 -->
        <van-popup v-model="showList"
                   position="bottom">
          <!-- onAdd、onEdit跳转到页面上面 -->
          <van-contact-list v-model="chosenContactId"
                            :list="list"
                            @add="onAdd1"
                            @edit="onEdit1"
                            @select="onSelect" />
        </van-popup>

        <!-- 联系人编辑 -->
        <van-popup v-model="showEdit"
                   position="bottom">
          <van-contact-edit :contact-info="editingContact"
                            :is-edit="isEdit"
                            @save="onSave"
                            @delete="onDelete" />
        </van-popup>
      </van-cell-group>

      <van-cell-group>
        <van-card :title="item.name"
                  :desc="item.color+'-'+item.size"
                  :num="item.count"
                  :price="item.price"
                  :thumb="item.goodsDetail.imgsrc"
                  v-for="item in goods"
                  :key="item.id" />
      </van-cell-group>

      <van-cell-group>
        <div class='bill changePad clearfix'>
          <span>运费</span>
          <span></span>
          <span>满88元免邮</span>
        </div>
      </van-cell-group>

      <van-cell-group>
        <div class='goods-sum'>
          <span>共<span class='good-num'>{{totalNum}}</span>件商品</span><span>小计：<span class='goods-price'>￥{{(totalPrice/100).toFixed(2)}}</span></span>
        </div>
      </van-cell-group>
    </div>
    <!-- <van-submit-bar :price="totalPrice"
                    button-text="提交订单"
                    @submit="onSubmit" /> -->
    <div class="van-submit-bar__bar">
      <div class="van-submit-bar__price"><span class="van-submit-bar__price-text">共<span class='good-num'>{{totalNum}}</span>件，合计：</span><span class="van-submit-bar__price-interger">￥{{(totalPrice/100).toFixed(2)}}</span><span class="van-submit-bar__price-decimal"></span></div><button @click="onSubmit"
              class="van-button van-button--danger van-button--normal"><span class="van-button__text">
          提交订单
        </span></button>
    </div>
  </div>
</template>

<script>
import store from '@/vuex/store'
import { mapState } from 'vuex'
import { Toast } from 'vant'
import { Dialog } from 'vant'
import { fdatasync, constants } from 'fs';
import { delimiter } from 'path';
import { debug, debuglog } from 'util';
//import {eventBus} from '../../assets/js/eventBus'

export default {
  store,
  data () {
    return {
      chosenContactId: null,
      editingContact: {},
      showList: false,
      showEdit: false,
      isEdit: false,
      desc: '',
      kid: '',
      list: [{
        name: '张三',
        tel: '13000000000',
        id: 0,
        address: '广州市天河区跃进路11号'
      }],
      showType: false,
      paylist: ['支付宝', '微信', '中国建设银行'],
      payResult: ['支付宝'],
      goods: [],
      paysum: '',
      personName: "",
      personPhone: "",
      personAddress: "",
      sumbitTime: '',
      targetAddress: {}, //修改传值的地址对象
      detailChosenList: {} //选中的sku属性对象
    };
  },
  computed: {
    cardType () {
      return this.chosenContactId !== null ? 'edit' : 'add';
    },
    currentContact () {
      const id = this.chosenContactId;
      return id !== null ? this.list.filter(item => item.id === id)[0] : {};
    },
    ...mapState({
      selectGoods: state => state.selectGoods,//绑定store.selectGoods到组件，之后可用this.selectGoods获取
      toBuy: state => state.toBuy,//直接购买
      isRightToBuy: state => state.isRightToBuy,
      allGood: state => state.allGood,
      toBepay: state => state.toBepay,
      tosendgood: state => state.tosendgood
    }),
    totalPrice () {
      //  return this.goods.reduce((total, item) => total + parseInt(item.price)*item.count)
      let sumResult = 0
      this.goods.forEach((item, index) => {
        sumResult += item.price * item.count * 100
      });
      return sumResult
    },
    totalNum () {
      //  return this.goods.reduce((total, item) => total + parseInt(item.price)*item.count)
      let sumResult = 0
      this.goods.forEach((item, index) => {
        sumResult += item.count
      });
      return sumResult
    },
  },
  created () {
    //直接购买和加入购物车的区别
    debugger
    this.goods.length = 0;
    //判断是从购物车还是购物详情页 0、详情、1购物车
    if (this.$route.params.isDetailOrCart == 0) {
      this.goods.push(this.$store.state.detailChosenList);
    } else {
      this.goods = this.$store.state.cartGoodstoPay; // 直接购物车的全部信息
    }
    console.log(this.goods);
  },
  mounted () {
    //debugger
    this.list = this.$store.state.addressList;
    this.detailChosenList = this.$store.state.detailChosenList;
    console.log("this.$store.state.detailChosenList");
    console.log(this.$store.state.detailChosenList);

    //返回
    window['backToDetail'] = () => {
      debugger
      this.onClickLeft();
    }
  },

  methods: {
    onAdd1 () {
      //debugger
      //编辑完成，就要跳转回此订单
      this.targetAddress.isBuyCard = 1;//从购物车进入
      this.$store.commit('getTargetAddress', this.targetAddress);
      this.$router.push('/addAddress/0/1');
    },
    onEdit1 (item, index) {
      item.isBuyCard = 1;//从购物车进入

      this.targetAddress = item;
      this.$store.commit('getTargetAddress', item);
      this.$router.push('/addAddress/1/0');
    },
    // 添加联系人
    //原本添加信息
    onAdd () {
      this.editingContact = { id: this.list.length };
      this.isEdit = false;
      this.showEdit = true;
    },
    onClickLeft () {
      Dialog.alert({
        message: '确定离开页面吗？此订单信息将会保存到待支付中'
      }).then(() => {
        console.log('time:' + this.formDate());
        this.toBuy[0].desc = '待支付';
        this.toBuy[0].whichList = '1';//待支付的订单状态
        //     this.allGood.push(this.toBuy[0]);
        this.toBepay.push(this.toBuy[0]);
        store.commit('change_isRightToBuy');

        this.$router.go(-1);
      });
      // let isLeave = confirm("确定离开吗？此订单信息将会保存到待支付中");
      // if (isLeave) {
      //   console.log('time:' + this.formDate());
      //   //确定离开，将此订单加入到待支付中
      //   this.toBuy[0].desc = '待支付';
      //   this.toBuy[0].whichList = '1';//待支付的订单状态
      //   //     this.allGood.push(this.toBuy[0]);
      //   this.toBepay.push(this.toBuy[0]);
      //   store.commit('change_isRightToBuy');
      //   this.$router.go(-1);
      // } else {
      //   return;
      // }
    },
    // 编辑联系人
    onEdit (item) {
      this.isEdit = true;
      this.showEdit = true;
      this.editingContact = item;
    },

    // 选中联系人
    onSelect () {
      this.showList = false;
    },

    // 保存联系人
    onSave (info) {
      this.showEdit = false;
      this.showList = false;

      if (this.isEdit) {
        this.list = this.list.map(item => item.id === info.id ? info : item);
      } else {
        this.list.push(info);
      }
      this.chosenContactId = info.id;
    },

    // 删除联系人
    onDelete (info) {
      this.showEdit = false;
      this.list = this.list.filter(item => item.id !== info.id);
      if (this.chosenContactId === info.id) {
        this.chosenContactId = null;
      }
    },
    //提交订单
    onSubmit () {
      //console.log(this.selectGoods);//从购物车进入选中的
      // console.log(this.goods);//直接购买的订单
      let that = this
      if (this.chosenContactId == null) {
        Toast('请添加收货地址');
      } else {
        //页面跳转到选择支付类型页面
        //debugger;
        this.paysum = (this.totalPrice / 100).toFixed(2);
        //提交的订单记录加入
        for (let i = 0; i < that.goods.length; i++) {
          that.goods[i].desc = '已支付';
          that.goods[i].personName = this.currentContact.name;
          that.goods[i].personPhone = this.currentContact.tel;
          that.goods[i].personAddress = this.currentContact.address;
          that.goods[i].sumbitTime = this.formDate();
          that.goods[i].whichList = '0',//订单类型-已支付
            this.allGood.push(that.goods[i]);
          //  this.tosendgood.push(that.goods[i]);
        }
        that.goods.forEach((item, index) => {
          //			    	that.selectGoods.splice(index, 1);
          that.$store.dispatch('removeGoods', index)
        });
        console.log(this.totalPrice);
        this.$router.push({ path: `/submit_pay/${this.paysum}` });
      }
    }
  },
  watch: {
    payResult (e, old) {
      //		let index = this.payResult.indexOf(old);
      //		if (index != -1) {
      //			this.payResult.splice(index, 1);
      //		}
      //如果存在两个值，就把old的值去掉，保留最新的值
      if (this.payResult.length > 1) {
        this.payResult.splice(0, 1);
      }
      this.showType = false
    }
  }
};
</script>

<style lang="less" scope>
.pay {
  .van-submit-bar__bar {
    width: 100%;
    position: fixed;
    bottom: 0px;
  }
  //本页面通用字体和颜色
  .common-font-b {
    font-size: 0.26rem;
    color: #000;
  }
  .common-font-g {
    font-size: 0.24rem;
    color: rgb(94, 94, 94);
  }

  .van-nav-bar .van-icon {
    font-weight: bold;
    color: #000;
    vertical-align: middle;
  }
  .van-nav-bar__text {
    display: none;
  }
  .van-nav-bar__title {
    font-weight: bold;
    font-size: 0.36rem;
  }
  .van-contact-card__content {
    padding: 0;
    height: 1.88rem;
  }
  .van-contact-list {
    padding-bottom: 0;
  }
  .van-contact-list__add {
    display: none;
  }
  .van-contact-list__edit {
    display: none; //图标隐藏(导航问题)
  }
  .van-contact-card--add .van-contact-card__icon {
    opacity: 0;
    display: none !important; //图标隐藏(导航问题)
  }
  .van-icon-contact {
    &::before {
      content: "";
    }
  }
  .van-contact-card__text {
    margin: 0 auto;
    font-size: 0.28rem;
    color: rgb(255, 144, 0);
    padding: 0 0.5rem;

    & > div:nth-child(1) {
      margin-bottom: 10px;
    }
  }
  .bill {
    line-height: 0.88rem;
    height: 0.88rem;
    span {
      display: block;

      &:nth-child(1) {
        float: left;
        .common-font-b;
      }
      &:nth-child(3) {
        float: right;
        .common-font-g;
      }
      &:nth-child(2) {
        float: right;

        width: 0.38rem;
        height: 0.88rem;
        // background: url("../../../static/image/goods/切图/填写订单/ios/more.png")
        //   no-repeat center center;
        margin-left: 0.15rem;
        line-height: 0.88rem;
      }
    }
  }
  .goodMsg {
    width: 100%;
    padding: 0.28rem 0 0.24rem;
    .common-font-b;
  }
  // .van-card__thumb {
  //   top: 5px;
  //   left: 15px;
  //   width: 1.38rem;
  //   height: 1.38rem;
  //   position: absolute;
  //   background: url("../../../static/image/goods/切图/填写订单/ios/Photo.png")
  //     no-repeat center center;
  //   border-radius: 0.08rem;
  //   overflow: hidden;
  // }
  // .van-card__content {
  //   margin-left: -0.1rem;
  //   width: 100%;
  // }
  // .van-card__title {
  //   max-height: 40px;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  //   display: -webkit-box;
  //   -webkit-line-clamp: 2;
  //   -webkit-box-orient: vertical;
  //   .common-font-b;
  // }
  // .van-card__price {
  //   .common-font-b;
  // }
  // .van-card__desc {
  //   .common-font-g;
  //   max-height: 20px;
  //   overflow: hidden;
  //   white-space: nowrap;
  //   text-overflow: ellipsis;
  // }
  // .van-card__num {
  //   .common-font-g;
  // }
  .changePad {
    padding: 0 0.24rem;
  }
  .goods-sum {
    padding: 0.26rem 0.24rem;
    font-size: 0.24rem;
    text-align: right;

    span {
      display: inline-block;

      &:nth-child(1) {
        margin-right: 0.16rem;
      }
      &:nth-child(2) {
        &:nth-child(1) {
          margin-right: 0.18rem;
        }
      }
      .good-num {
        color: rgb(255, 144, 0);
      }
      .goods-price {
        color: rgb(255, 144, 0);
        font-size: 0.3rem;
      }
    }
  }
  .van-submit-bar__price {
    text-align: right !important;
    span {
      text-align: right;
      display: inline-block;
      font-size: 0.24rem;
      color: #000;

      .good-num {
        color: rgb(255, 144, 0);
      }
    }
  }
  .van-submit-bar__price-interger,
  .van-submit-bar__price-decimal {
    color: rgb(255, 144, 0) !important;
    font-size: 0.3rem !important;
  }
  .van-button--normal {
    padding: 0 15px;
    font-size: 14px;
    width: 2.5rem;
    background-color: rgb(255, 144, 0);
    border: 1px solid rgb(255, 144, 0);
    border-radius: 0;
    height: 100%;
  }
  //重置vant-card
  .van-card {
    padding: 0.32rem 0.24rem;
    //重要的
    height: auto;

    .van-card__thumb {
      position: relative;
      top: 0;
      left: 0;
      width: 1.68rem;
      height: 1.68rem;
      margin-right: 0.2rem;
      // background: url("../../../static/image/goods/切图/填写订单/ios/Photo.png")
      //   no-repeat center center;

      & > img {
        // display: none;
      }
    }

    .van-card__content {
      position: relative;

      .van-card__row {
        margin-bottom: 0.16rem;

        .van-card__title {
          font-size: 0.26rem;
          color: rgb(51, 51, 51);
        }

        .van-card__price {
          font-size: 0.32rem;
          color: rgb(255, 144, 0);
          position: absolute;
          left: 0;
          top: 1.3rem;
          text-align: left;
        }

        .van-card__desc {
          font-size: 0.22rem;
          color: rgb(153, 153, 153);
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/pay/pay.vue